import React, { Component } from 'react';
import './Disclaimer.css';
import { withTranslation } from 'react-i18next';

class Disclaimer extends Component {
    render() {
        return (
            <p className="disclaimer">{this.props.t('Disclaimer')}</p>
        );
    }
}

export default withTranslation()(Disclaimer);


// WEBPACK FOOTER //
// ./src/Disclaimer.js